/**
 * KittyBOT Cookie Preferences trigger.
 *
 * Reopens the official Shopify cookie preferences dialog via
 * globalThis.privacyBanner.showPreferences() (the ShopPay / storefront
 * Customer Privacy banner API). This script does NOT read or write cookies,
 * does NOT set tracking consent, and does NOT load a second banner.
 */
(() => {
  const TRIGGER_SELECTOR = '[data-cookie-preferences], [data-cookie-preferences-trigger]';
  const STATUS_SELECTOR = '[data-cookie-preferences-status]';
  const PRIVACY_READY_EVENT = 'shopifyCustomerPrivacyApiLoaded';
  const MAX_WAIT_MS = 15000;
  const POLL_INTERVAL_MS = 100;

  function getPrivacyBanner() {
    const banner = globalThis.privacyBanner;

    if (banner && typeof banner.showPreferences === 'function') {
      return banner;
    }

    return null;
  }

  function waitForPrivacyBanner() {
    const existingBanner = getPrivacyBanner();

    if (existingBanner) {
      return Promise.resolve(existingBanner);
    }

    return new Promise((resolve, reject) => {
      const startedAt = Date.now();
      let settled = false;

      const cleanup = () => {
        window.clearInterval(timer);
        document.removeEventListener(PRIVACY_READY_EVENT, handlePrivacyReady);
      };

      const resolveIfReady = () => {
        const banner = getPrivacyBanner();

        if (banner && !settled) {
          settled = true;
          cleanup();
          resolve(banner);
        }
      };

      const handlePrivacyReady = () => {
        // Shopify can dispatch the ready event just before assigning the global.
        // Keep the short poll alive so the first click still succeeds.
        resolveIfReady();
      };

      document.addEventListener(PRIVACY_READY_EVENT, handlePrivacyReady);

      const timer = window.setInterval(() => {
        resolveIfReady();

        if (!settled && Date.now() - startedAt >= MAX_WAIT_MS) {
          settled = true;
          cleanup();
          reject(
            new Error(
              'Shopify Cookie Banner API was not available within the expected time.'
            )
          );
        }
      }, POLL_INTERVAL_MS);
    });
  }

  function setStatus(message) {
    const statusRegion = document.querySelector(STATUS_SELECTOR);

    if (statusRegion) {
      statusRegion.textContent = message;
    }
  }

  async function openCookiePreferences(trigger) {
    if (!trigger || trigger.dataset.loading === 'true') {
      return;
    }

    trigger.dataset.loading = 'true';
    trigger.setAttribute('aria-busy', 'true');

    try {
      const banner = await waitForPrivacyBanner();

      await banner.showPreferences();
    } catch (error) {
      if (document.documentElement.classList.contains('shopify-design-mode')) {
        console.error('[KittyBOT] Unable to open Shopify Cookie Preferences.', error);
      }

      setStatus(
        'Cookie preferences are temporarily unavailable. Please refresh the page and try again.'
      );

      document.dispatchEvent(
        new CustomEvent('kittybot:cookie-preferences-error')
      );
    } finally {
      trigger.dataset.loading = 'false';
      trigger.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(TRIGGER_SELECTOR);

    if (!trigger) {
      return;
    }

    event.preventDefault();
    openCookiePreferences(trigger);
  });
})();
